import React from 'react'

import { Deal } from '~/gql/graphql'

import BroadbandContent from './broadband-content'
import CostsContent from './costs-content'
import PhoneContent from './phone-content'
import ProviderContent from './provider-content'
import TVContent from './tv-content'

export const getContent = (deal: Deal) => {
  const { provider, services } = deal

  const tabs = [
    {
      title: 'Costs',
      body: <CostsContent deal={deal} />
    }
  ]

  if (services.broadband)
    tabs.push({
      title: 'Broadband',
      body: <BroadbandContent broadband={services.broadband} provider={provider} />
    })

  const telephone = services?.telephone
  const inclusiveCalls = telephone?.inclusiveCalls

  if (telephone && inclusiveCalls && inclusiveCalls !== 'none')
    tabs.push({
      title: 'Phone',
      body: <PhoneContent telephone={telephone} />
    })

  if (services?.tv?.channelCount || services?.tv?.channels)
    tabs.push({
      title: 'TV',
      body: <TVContent tv={services.tv} />
    })

  tabs.push({
    title: 'Provider',
    body: <ProviderContent provider={provider} terms={deal.terms} />
  })

  return tabs
}
